var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hidden-input',_vm._b({attrs:{"value":_vm.person.notes,"editable":!_vm.saving,"scope":"person"}},'hidden-input',_vm.notes,false))}
var staticRenderFns = []

export { render, staticRenderFns }